export enum Factor {
  POSITIVE = 'POSITIVE', // 긍정
  ACTIVE = 'ACTIVE', // 적극
  STRATEGY = 'STRATEGY', // 전략
  CONTROL = 'CONTROL', // 제어
  RELATION = 'RELATION', // 관계
  OBJECTIVITY = 'OBJECTIVITY', // 객관
  INTROSPECTIVE = 'INTROSPECTIVE', //성찰
}

export const factorTypeStringMap: Record<FactorType, string> = {
  POSITIVE: '긍정',
  ACTIVE: '적극',
  STRATEGY: '전략',
  CONTROL: '제어',
  RELATION: '관계',
  OBJECTIVITY: '객관',
  INTROSPECTIVE: '성찰',
};

export type FactorType = keyof typeof Factor;

interface IFactorTypeContents {
  name: string;
  description: string;
}

const POSITIVE: IFactorTypeContents = {
  name: '긍정',
  description: '자신의 환경에 대한 긍정적인 믿음과 더 나아가려고 하는 진취적인 태도를 의미합니다.',
};

const ACTIVE: IFactorTypeContents = {
  name: '적극',
  description: '자신의 성장과 더 큰 성과를 내고자 하는 강렬한 열망과 의지를 의미합니다.',
};

const STRATEGY: IFactorTypeContents = {
  name: '전략',
  description: '성과를 내기 위해 내•외부의 변수를 파악하여 효과적으로 전략을 수립하는 능력을 의미합니다.',
};

const CONTROL: IFactorTypeContents = {
  name: '제어',
  description: '목표 달성을 위해 행동을 꾸준히 지속하고 실행 과정에서 발생하는 돌발상황에 대응하는 능력을 의미합니다.',
};

const RELATION: IFactorTypeContents = {
  name: '관계',
  description: '다른 사람들의 감정과 의도를 잘 파악하며, 상황에 맞게 적절하게 말하고 행동하는 능력을 의미합니다.',
};

const OBJECTIVITY: IFactorTypeContents = {
  name: '객관',
  description: '내•외부 정보를 통합 및 비교하여 최적의 결정을 내리는 능력을 의미합니다.',
};

const INTROSPECTIVE: IFactorTypeContents = {
  name: '성찰',
  description: '겸손한 자세로 자신을 성찰하고 객관적으로 이해하려는\n태도를 의미합니다.',
};

export const factorTypeContentsMap: Record<FactorType, IFactorTypeContents> = {
  POSITIVE,
  ACTIVE,
  STRATEGY,
  CONTROL,
  RELATION,
  OBJECTIVITY,
  INTROSPECTIVE,
};
